import { createReducer } from "./functions";

import { ACTIONS_SET_LIST } from '../types';

const initialState = {
  actionsList: [],
  page: 0,
  pages: 0,
  pageSize: 10
}

const setActionsList = {
  [ACTIONS_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page")
    ? action.payload.page
    : state.page;
    const pages = action.payload.hasOwnProperty("pages")
      ? action.payload.pages
      : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages)
      hasNext = false;
    return { ...state, actionsList: action.payload.docs, page, pages, hasNext };
  }
}
const actionsReducer = createReducer(initialState, {
  ...setActionsList
})

export default actionsReducer;


// WEBPACK FOOTER //
// src/redux/reducers/actionsReducer.js